export default [
  {name: 'OUI', value: true},
  {name: 'NON', value: false},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/fr/arrays/yesno.js